import React from 'react'
import './SessionDetailpopupStyle.css'
import Button from '../../Button/Button'
import TextArea from '../../TextArea/TextArea';
import '../ReSchedulePopup/ReSchedulePopupStyle.css'
import ProfileCard from '../../ProfileCard/ProfileCard';
import moment from 'moment';

const SessionDetailpopup = ({ isActive, setIsActive, mentorData, selectedDate, selectedSlot, agenda ,errorAgenda, handleAgendaChange,onScheduleCall, handleDiscard, handleClose }) => {

    return (
        <div className={`popupWrapper poupviewtab ${isActive && "active"}`}>
            <div className={`popupContainer SessionDspopupadd`}>
                <div className="popupBody">
                    <span className="closebtn mb10">
                        <img src="/assets/svg/close.svg" alt="" onClick={handleClose} />
                    </span>
                    <div className="headingpoup">
                        <h3>Session Details</h3>
                    </div>

                    <div className='flex WrapReschedulepoup'>
                        <div className="ReSchedulepoupleft">
                            <div className="menterdataSession">
                                <p className='text3 mb-30'>Web conferencing details chosen as per Indian Standard Time are as follows:</p>
                                <div className="CallDetailsNameData">
                                    <span className="Mentorspan Designspan">Mentor</span>
                                    <div className="NameDetails mt10">
                                        <h3 className="namelink pointer mb-5">{mentorData?.firstName ? `${mentorData?.firstName} ${mentorData?.lastName}` : "---"}</h3>
                                        <p className="text2">{mentorData?.profession?.designation ? mentorData?.profession?.designation : "---"}, {mentorData?.profession?.company ? mentorData?.profession?.company : "---"}</p>
                                    </div>

                                </div>

                                {mentorData?.languages?.length > 0 && <div className="flex mt-15 gap-10">
                                        {mentorData?.languages?.map((item, index) => (
                                            <div className="coursesTag" key={index}>{item?.name}</div>
                                        ))}
                                    </div>}
                            </div>
                        
                            <div className="AdCardsProfilWrapper flex gap-10 mt-40 SessionPcardadd" >
                                    <ProfileCard number={moment(selectedDate).utcOffset("-00:00").format("DD MMMM, YYYY")}  text={'Date'} img={"/assets/img/tickpoup.png"} />
                                    <ProfileCard className={'purpleCard'} number={selectedSlot.time ? moment(selectedSlot.time).utcOffset("-00:00").format("hh:mm a") : "---"} text={'Time'} img={"/assets/img/clockyellow.png"} />
                                </div>

                        </div>

                        <div className="ReSchedulepoupright">
                            <div className="Rstextpoup">
                                <p className='text3'>Kindly state the purpose for call or the specifics of your discussion:</p>
                            </div>

                            <TextArea placeholder={'Example: I wish to know more about taxation and investment planning.'} labelName="Agenda" className={'textareaRc'} value={agenda} onChange={handleAgendaChange} errorMessage={errorAgenda} />
                        </div>
                    </div>

                    <div className='flex-center gap-20 mt-60 Rcbuttonfooter'>
                        <Button name={'Back'} className={'GreyFillButton'} onClick={handleDiscard} />
                        <Button name={'Schedule'} className={'DarkblueFillButton'} onClick={onScheduleCall} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SessionDetailpopup